import axios from 'axios'
import Cookies from 'universal-cookie'
import config from 'config'

import { mapErrorCodes } from 'helpers'

const commonHeaders = () => ({
  'Content-Type':     'application/json',
  'Accept-Language':  config.require('LOCALE'),
})

window._addedCommonHeaders = {}
window._addedResponseTransformers = []

const cookies = new Cookies()

export const addCommonHeaders = headers => {
  Object.assign(window._addedCommonHeaders, headers)
}

export const addResponseTransformer = transformer => {
  window._addedResponseTransformers.push(transformer)
}

const applyTransformers = data => {
  let json = null
  try {
    json = JSON.parse(data)
  }
  catch(e) {}

  window._addedResponseTransformers.forEach(transformer => {
    json = transformer(json)
  })

  return json
}

export const http = (headers = {}) => {
  const httpOptions = {
    baseURL: config.get('BASE_API_URL'),
    headers: { ...commonHeaders(), ...window._addedCommonHeaders, ...headers },
    withCredentials: true
  }

  if (window._addedResponseTransformers.length > 0) {
    httpOptions.transformResponse = applyTransformers
  }

  const http = axios.create(httpOptions)

  if (config.require('ENVIRONMENT') === 'development' && typeof config.get('initMocks') === 'function') {
    config.get('initMocks')(http)
  }

  http.interceptors.request.use(request => {
    const logMessage = `Started ${request.method.toUpperCase()} ${request.url}`
    if (request.data) console.log(logMessage, request.data)
    else console.log(logMessage)
    return request
  })

  http.interceptors.response.use(response => {
    console.log(`Received ${response.status} ${response.config.method.toUpperCase()} ${response.config.url}`, response.data)
    return response
  }, error => {
    if (error.response) {
      const codes = mapErrorCodes({ response: { data: error.response.data } })
      if (codes.indexOf('invalid_preview_token') > -1) {
        return window.dispatchEvent(new Event('previewTokenExpired'))
      }
    }

    if(error.response) console.log(`Received ${error.response.status} ${error.response.config.method.toUpperCase()} ${error.response.config.url}`, error.response.data)
    return Promise.reject(error)
  })

  return http
}
